/**
 * DESIGN PASS 20 — the band's sentence.
 *
 * THE BAND SAYS WHAT IS TRUE. AI CHAD SAYS WHAT HE THINKS.
 * This sentence is a fact derived from the active project count. It does not
 * change with the hour, it does not advise, and it never addresses the user.
 * If it ever starts advising it has become AI Chad; if AI Chad ever starts
 * counting he has become this.
 *
 * All the wording lives here, in one place, so it can be changed without
 * touching the component. Bodoni carries the words; the numeral is handed
 * back separately because no digit is ever on the display face.
 */
export const BAND_SENTENCE = {
  many: { pre: '', post: ' things are moving.' },
  one: 'One thing is moving.',
  none: 'Nothing is moving yet.',
};

/** Returns { pre, numeral, post } — `numeral` is null when there is no digit. */
export function bandSentence(activeCount) {
  const n = Number(activeCount) || 0;
  if (n <= 0) return { pre: BAND_SENTENCE.none, numeral: null, post: '' };
  if (n === 1) return { pre: BAND_SENTENCE.one, numeral: null, post: '' };
  return { pre: BAND_SENTENCE.many.pre, numeral: String(n), post: BAND_SENTENCE.many.post };
}

/**
 * DP82 Part 4 — the PORTFOLIO sentence, for /projects.
 *
 * Same rule as the band sentence above: it states a fact and never advises.
 * Two clauses, because the page is about two things — how much work there is,
 * and how much of it is waiting on Chad. Bodoni carries the words; both
 * numerals are handed back separately because no digit goes on the display
 * face. `needing` is overdue + decisions, counted once.
 *
 * When nothing needs anything it must STILL be a sentence, not a blank or a
 * zero: "Eleven projects, all clear."
 */
export function portfolioSentence(activeCount, needingCount) {
  const a = Number(activeCount) || 0;
  const n = Number(needingCount) || 0;
  const projects = a === 1 ? ' project,' : ' projects,';
  if (a <= 0) return { pre: 'No projects yet.', numeral: null, mid: '', numeral2: null, post: '' };
  if (n <= 0) return { pre: '', numeral: String(a), mid: projects, numeral2: null, post: ' all clear.' };
  return {
    pre: '', numeral: String(a), mid: projects,
    numeral2: String(n), post: n === 1 ? ' needs something.' : ' need something.',
  };
}
